import createTableStore from "ds/components/Table/hooks/useTableStore";

import { STACKS_COLUMN_CONFIG, STACKS_COLUMNS_STORAGE_KEY } from "./constants";

const useStacksTableStore = createTableStore({
  storageKey: STACKS_COLUMNS_STORAGE_KEY,
  config: STACKS_COLUMN_CONFIG,
});

export default useStacksTableStore;
